/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { theme } from "styles";
import Text from "components/ui/Text";
import LeftArrow from "assets/icons/left-arrow.svg";

const EntranceTemplate = ({ title, topContent, btmContent, onClickBack }) => {
  const navigate = useNavigate();
  const pageRef = useRef();
  const [height, setHeight] = useState(null);

  useEffect(() => {
    window.visualViewport.addEventListener("resize", (e) => {
      const pageHeight = e.target.height;
      setHeight(pageHeight + scrollY);
    });
    return;
  }, []);

  const handleClickBack = () => {
    if (onClickBack) {
      onClickBack();
      return;
    }
    navigate(-1);
  };

  return (
    <Wrapper ref={pageRef} height={height}>
      <WrapperTop>
        <WrapperHeader>
          <div onClick={handleClickBack}>
            <img src={LeftArrow} alt="back" />
          </div>
        </WrapperHeader>
        <Text fontSize="24px" fontWeight="700" lineHeight="30px">
          {title}
        </Text>
        {topContent}
      </WrapperTop>
      <WrapperBtm>{btmContent}</WrapperBtm>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 20px 42px;
  background: #fff;
  height: ${(props) => (props.height ? `${props.height}px` : "100%")};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;
  .footer {
    position: absolute;
    bottom: 0;
    width: 100vw;
    height: 56px;
    margin-left: -20px;
    padding: 16px 24px;
    text-align: center;
    background: ${theme.colors["primary100"]};
  }
  .footer-disable {
    background: ${theme.colors["gray5"]};
  }
`;
const WrapperTop = styled.div`
  white-space: pre;
`;
const WrapperHeader = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  div {
    padding: 4px 20px 4px 0;
  }
`;
const WrapperBtm = styled.div``;

export default EntranceTemplate;
